import { t } from "@/i18n-js/instance";
import { EntityResource } from "../EntityResource";
import type { EventOption } from "../types";
import { AnyPaywallSpecificSelector } from "./shared/AnyPaywallSpecificSelector";

export const couponUsedAtCheckout: Readonly<EventOption> = {
  label: t(
    "workflows_v2.events.community_member_coupon_used_at_checkout.title",
  ),
  value: "community_member_coupon_used_at_checkout",
  group: t("settings.workflows.form.event_groups.paywalls"),
  description: t(
    "workflows_v2.events.community_member_coupon_used_at_checkout.description",
  ),
  formComponent: AnyPaywallSpecificSelector,
  viewComponent: EntityResource,
  icon: "paywall",
};
